/* Éllan — Bluorng-style peek carousel (mobile only).
   Any [data-peek-carousel] becomes a centered Swiper with peeking neighbors
   below 750px, and is destroyed above it. Reuses the theme's bundled Swiper. */
(function () {
  var mq = window.matchMedia('(max-width: 749px)');
  var instances = [];

  function initAll() {
    if (typeof Swiper === 'undefined') return;
    document.querySelectorAll('[data-peek-carousel]').forEach(function (el) {
      if (el.swiper) return;
      var per = parseFloat(el.getAttribute('data-peek-per')) || 1.15;
      var gap = parseInt(el.getAttribute('data-peek-gap'), 10);
      if (isNaN(gap)) gap = 12;
      var pag = el.querySelector('.swiper-pagination');
      var count = el.querySelectorAll('.swiper-slide').length;
      // Infinite loop only where opted in AND there are enough slides. Loop is
      // avoided with pagination (Swiper's fractional-centered loop miscounts
      // bullets), so loop carousels should not render dots.
      var doLoop = el.getAttribute('data-peek-loop') === 'true' && count > 2;
      instances.push(
        new Swiper(el, {
          slidesPerView: per,
          centeredSlides: true,
          spaceBetween: gap,
          grabCursor: true,
          watchOverflow: true,
          slideToClickedSlide: true,
          loop: doLoop,
          rewind: !doLoop,
          pagination: pag ? { el: pag, clickable: true } : false,
        })
      );
    });
  }

  function destroyAll() {
    instances.forEach(function (s) {
      if (s && s.destroy) s.destroy(true, true);
    });
    instances = [];
  }

  function update() {
    if (mq.matches) initAll();
    else destroyAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', update);
  } else {
    update();
  }

  if (mq.addEventListener) mq.addEventListener('change', update);
  else if (mq.addListener) mq.addListener(update);

  document.addEventListener('shopify:section:load', update);

  var scheduled = false;
  new MutationObserver(function () {
    if (scheduled || !mq.matches) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      initAll();
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
